import { ACTION_TYPE } from './action';

// region Reducer
const surveySetting = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_INIT_SURVEY_SETTING_SUCCESS:
      return {
        ...state,
        stores: action.stores,
      };
    case ACTION_TYPE.CALL_API_GET_SURVEY_SETTING_SUCCESS:
      return {
        ...state,
        datas: action.datas,
      };
    case ACTION_TYPE.CALL_API_UPSERT_SURVEY_SETTING_SUCCESS:
      return {
        ...state,
        isUpdateSuccess: true,
        data: action.data,
      };
    case ACTION_TYPE.RESET_SURVEY_SETTING_FLG:
      return {
        ...state,
        isUpdateSuccess: false,
      };
    default:
      return state;
  }
};

export default surveySetting;
